define('ordersUnpaidView',[
  'module',
  'marionette',
  'underscore',
  'ordersUnpaidTableView',
  'ordersUnpaidTotalsView',
  'template!ordersUnpaidView'
], function (
  Module,
  Marionette,
  _,
  TableView,
  TotalsView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'unpaid-orders-view',

    regions: {
      totalsRegion: '.totals-region',
      tableRegion: '.table-region'
    },

    onShow: function() {
      this.tableView = new TableView({type: 'command'});
      this.getRegion('tableRegion').show(this.tableView);

      this.totalsView = new TotalsView({tableView: this.tableView});
      this.getRegion('totalsRegion').show(this.totalsView);
    }
  });
});

